import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import styles from "./style.module.scss";
import { plan_status } from "pages/membership/constant";
import { Icons } from "assets";
import classNames from "classnames";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface SchoolPlanDetailProps {
  open: boolean;
  handleClose: any;
  selectedItem: any;
}

export default function SchoolPlanDetail({
  open,
  handleClose,
  selectedItem
}: SchoolPlanDetailProps) {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: (theme) => theme.spacing(125),
              position: "relative"
            }
          }
        }}
      >
        <DialogContent>
          <div className={styles.crossIcon}>
            <Icons.CrossIcon onClick={handleClose} />
          </div>
          <div>
            <div
              className={classNames(
                styles.topLevel,
                styles.planFormModalWrapper
              )}
            >
              <div className={styles.title}>For School Account</div>
            </div>

            <div className={styles.tableWrapper}>
              <div className={styles.twoColumnsGrid}>
                <div className={styles.gridCell}>
                  <span>School Name</span>
                  <span className={styles.capitalize}>
                    {selectedItem?.school_name}
                  </span>
                </div>
                <div className={styles.gridCell}>
                  <span>Plan Name</span>
                  <span className={styles.capitalize}>
                    {selectedItem?.name}
                  </span>
                </div>
                <div className={styles.gridCell}>
                  <span>Plan Type</span>
                  <span>
                    {selectedItem?.type === 1
                      ? "Regular"
                      : selectedItem?.type === 2
                      ? "Promotional"
                      : "Invalid"}
                  </span>
                </div>
                <div className={styles.gridCell}>
                  <span>Plan Duration</span>
                  <span>{selectedItem?.duration + " Days"}</span>
                </div>

                <div className={styles.gridCell}>
                  <span>
                    Amount (
                    {selectedItem?.level === 1 || selectedItem?.level === 2
                      ? "Rs"
                      : "$"}
                    )
                  </span>
                  <span>{selectedItem?.price}</span>
                </div>
                <div className={styles.gridCell}>
                  <span>Status</span>
                  <span>
                    {selectedItem?.status === 1
                      ? "Active"
                      : selectedItem?.status === 2
                      ? "Expired"
                      : "Pending"}
                  </span>
                </div>
                {/* {selectedItem?.is_discounted ? (
                  <>
                    <div className={styles.gridCell}>
                      <span>Discount Title</span>
                      <span>{selectedItem?.title}</span>
                    </div>
                    <div className={styles.gridCell}>
                      <span>Discount Price</span>
                      <span>{selectedItem?.discounted_price}</span>
                    </div>
                    <div className={styles.gridCell}>
                      <span>Discount Start Date</span>
                      <span>{selectedItem?.start_date}</span>
                    </div>
                    <div className={styles.gridCell}>
                      <span>{selectedItem?.end_date}</span>
                    </div>
                  </>
                ) : null} */}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
